// extracted by mini-css-extract-plugin
export default {"transform":"styles_transform__8fWxv","buttonLabel":"styles_buttonLabel__zFfax"};